import { Component, input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { AppInputDropdownComponent } from '@view/shared/molecules/input-dropdown/input-dropdown.component';
import { AppTranslationPipe } from '@adapter/i18n/app-translation.pipe';
import { AppInputOption } from '@helpers/input/input.option';

@Component({
  selector: 'app-upload-step-one',
  imports: [
    ReactiveFormsModule,
    InputTextModule,
    AppInputDropdownComponent,
    AppTranslationPipe
  ],
  templateUrl: './upload-step-one.component.html',
  styleUrl: './upload-step-one.component.scss'
})
export class UploadStepOneComponent {
  formGroup = input.required<FormGroup>();
  itemsTypeOperations = input<AppInputOption[]>([]);

  get isStepOneDone(): boolean {
    return (
      !!this.formGroup().get('typeOperation')?.valid &&
      this.isPolicyNumberReady
    );
  }

  get isStepOneIncomplete(): boolean {
    return !this.isStepOneDone;
  }

  get showPolicyNumberError(): boolean {
    return (
      !!this.policyNumberControl?.invalid &&
      (!!this.policyNumberControl.dirty || !!this.policyNumberControl.touched)
    );
  }

  get hasPolicyNumberPatternError(): boolean {
    return !!this.policyNumberControl?.errors?.['pattern'];
  }

  get hasPolicyNumberLengthError(): boolean {
    const errors = this.policyNumberControl?.errors;
    return !!errors?.['minlength'] || !!errors?.['maxlength'];
  }

  get isPolicyNumberReady(): boolean {
    const control = this.policyNumberControl;

    if (!control) {
      return false;
    }

    if (control.disabled) {
      return !!(control.value as string | null)?.trim();
    }

    return control.valid;
  }

  private get policyNumberControl(): AbstractControl | null {
    return this.formGroup().get('policyNumber');
  }
}
